import type { ReactNode } from 'react';
import { SparkleIcon } from '@/components/icons';
import { cn } from '@/utils/helpers';

interface FieldLabelRowProps {
  htmlFor?: string;
  children: ReactNode;
  required?: boolean;
  aiField?: string;
  aiFilledFields: string[];
  className?: string;
}

/** Label with optional AI sparkle on the right (operator + novice flows). */
export function FieldLabelRow({
  htmlFor,
  children,
  required,
  aiField,
  aiFilledFields,
  className,
}: FieldLabelRowProps) {
  const showSparkle = Boolean(aiField && aiFilledFields.includes(aiField));

  const labelClass = cn('form-kit__label', 'form-kit__label', className);
  const labelContent = (
    <>
      {children}
      {required ? <span className="form-kit__required"> *</span> : null}
    </>
  );

  return (
    <div className="form-kit__label-row form-kit__label-row">
      {htmlFor ? (
        <label className={labelClass} htmlFor={htmlFor}>
          {labelContent}
        </label>
      ) : (
        <span className={labelClass}>{labelContent}</span>
      )}
      {showSparkle ? <SparkleIcon className="form-kit__sparkle" size={18} /> : null}
    </div>
  );
}
